import { RouteObject } from 'react-router-dom'
import { Gate } from '@/components/shared/gate/Gate'
import { ListEmployee } from '@/pages/master/employee/ListEmployee'
import { Roles } from '@/utils/constants/roles'

const masterRoutes: RouteObject[] = [
  {
    path: '/master/employee',
    element: <Gate role={[Roles.AssistantDirector, Roles.ManagerHR, Roles.Director, Roles.StaffHR]} />,
    children: [{ index: true, element: <ListEmployee /> }],
  },
]
export default masterRoutes
